<template>
  <div class="editor-view">
    <!-- Das iframe mit der bearbeitbaren Webseite -->
    <iframe class="editorFrame" ref="editorFrame" src="http://module.dev.unico-gestaltung.de/"
            @load="setupEditor"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedElement: null, // Das aktuell ausgewählte Element
    };
  },
  methods: {
    setupEditor() {
      const iframeDoc = this.$refs.editorFrame.contentDocument;
      const editableArea = iframeDoc.querySelector('.editable-area');

      // Klick-Listener für die Auswahl des zu bearbeitenden Elements
      editableArea.addEventListener('click', (event) => {
        event.stopPropagation();
        this.selectElement(event.target);
      });
    },
    selectElement(element) {
      this.selectedElement = element; // Element speichern
      this.addResizeHandles(element); // Anfasser hinzufügen
    },
    addResizeHandles(element) {
      // Entferne bestehende Anfasser
      this.removeResizeHandles();

      // Anfasser für Padding und Margin hinzufügen
      ['top', 'right', 'bottom', 'left'].forEach((position) => {
        const handle = document.createElement('div');
        handle.className = `resize-handle ${position}`;
        handle.style.position = 'absolute';
        handle.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        handle.style.width = '10px';
        handle.style.height = '10px';
        handle.style.cursor = position + '-resize';

        // Positionierung der Anfasser
        if (position === 'top' || position === 'bottom') {
          handle.style.left = '50%';
          handle.style.transform = 'translateX(-50%)';
          handle.style[position] = '-5px';
        } else {
          handle.style.top = '50%';
          handle.style.transform = 'translateY(-50%)';
          handle.style[position] = '-5px';
        }

        // Drag-Event für die Anfasser
        handle.addEventListener('mousedown', (e) => this.onDragHandle(e, position));

        element.appendChild(handle); // Anfasser an das Element anhängen
      });
    },
    removeResizeHandles() {
      if (this.selectedElement) {
        const handles = this.selectedElement.querySelectorAll('.resize-handle');
        handles.forEach((handle) => handle.remove());
      }
    },
    onDragHandle(event, position) {
      const startX = event.clientX;
      const startY = event.clientY;
      const element = this.selectedElement;

      const startPadding = parseInt(window.getComputedStyle(element).padding) || 0;
      const startMargin = parseInt(window.getComputedStyle(element).margin) || 0;

      const onMouseMove = (e) => {
        let delta;
        if (position === 'left' || position === 'right') {
          delta = e.clientX - startX;
        } else {
          delta = e.clientY - startY;
        }

        // Padding und Margin aktualisieren
        if (event.shiftKey) { // Halte Shift gedrückt für Margin
          element.style.margin = startMargin + delta + 'px';
        } else {
          element.style.padding = startPadding + delta + 'px';
        }

        // Aktuelle Werte in der Sidebar aktualisieren (synchronisieren)
        this.$emit('update-style', 'padding', element.style.padding);
        this.$emit('update-style', 'margin', element.style.margin);
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    },
  },
};
</script>

<style>
.editor-view {
  height: 100%;
}

.resize-handle {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  width: 10px;
  height: 10px;
  z-index: 10;
}

.editorFrame {
  width: 100%;
  height: 100%;
}
</style>
